
    const mBody = document.getElementsByTagName('body')[0]
    function scrollHeightCheck() {
        window.scrollY >= 100 ? mBody.classList.add('scrolled') 
                         : mBody.classList.remove('scrolled')
    }
    document.onscroll = function() { scrollHeightCheck() }
    scrollHeightCheck()


const videos = document.querySelectorAll('video[autoplay]')

var motionQuery = matchMedia('(prefers-reduced-motion: reduce)');

function handleReduceMotionChanged() {
  if(videos) {
     videos.forEach(function (video, index) {
    if (motionQuery.matches) {
        video.removeAttribute('autoplay')
        
      
    } else {
       
       
    }

    });    
   }

                    

}

motionQuery.addEventListener("change", handleReduceMotionChanged)

handleReduceMotionChanged(); // trigger once on load




function setHeaderHeightVar() {
  const header = document.querySelector('.shopify-section-group-header-group');
  const announcement = document.querySelector('.announcement-bar-section');
  
  document.documentElement.style.setProperty(
    '--header-height',
    (header?.offsetHeight ?? 0) + 'px'
  );
  document.documentElement.style.setProperty(
    '--announcement-bar-height',
    (announcement?.offsetHeight ?? 0) + 'px'
  );
}

setHeaderHeightVar();
window.addEventListener('resize', setHeaderHeightVar);